export const GAMES_CACHE_TIME = 1000 * 60 * 60
export const GamesCacheKey = 'games'
